module.exports = __webpack_public_path__ + "static/media/sass.06012af6.png";